const { render, useState } = wp.element;
import React, { Component } from "react";
import { withTranslation } from "react-i18next";

//Import Designs
import {
    Typography,
    Grid2,
    Button,
    TextField,
    Dialog,
    DialogContent,
} from "@mui/material";
import ReactHtmlParser from "react-html-parser";

import SendIcon from "@mui/icons-material/Send";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

import VoterDetails from "./VoterDetails.jsx";
import Newsletter from "./Newsletter.jsx";
import CustomReactValidator from "../CustomReactValidator.jsx";

class EmailVerify extends Component {
    constructor(props) {
        super(props);
        this.state = { enter_email_code: "" };
        this.validator = new CustomReactValidator({
            validators: {
                verifycode: {
                    // name the rule
                    message: this.props.t("verification_code_not_matching"),
                    rule: (val, params, validator) => {
                        return (
                            parseInt(val) === parseInt(this.props.email_code)
                        );
                    },
                    messageReplace: (message, params) =>
                        message.replace(
                            ":values",
                            this.helpers.toSentence(params)
                        ), // optional
                    required: true, // optional
                },
                consent: {
                    message: this.props.t("consent_validation_text"),
                    rule: (val, params, validator) => {
                        return val || false;
                    },
                    messageReplace: (message, params) => {
                        return message.replace(":values", params);
                    },
                    required: true,
                },
            },
            messages: {
                email: this.props.t("email_validation"),
            },
        });
    }

    handleEmailverify = () => {
        if (this.validator.allValid()) {
            this.props.handleEmailverify();
        }
        // if (this.validator.fieldValid('email_address')) {
        //     this.props.handleEmailverify();
        // }
        else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    handleEmailCodeChange = (event) => {
        this.setState({ enter_email_code: event.target.value });
    };

    handleVerificationCode = () => {
        if (
            parseInt(this.state.enter_email_code) ===
            parseInt(this.props.email_code)
        ) {
            this.submitForm();
        } else {
            console.log("Error");
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    submitForm = () => {
        let post_index = this.props.indexpost;
        let vote_settings = this.props.settings.contest;
        let contest_settings = {};
        //Add the User ID from JS
        contest_settings.user_logged = this.props.short.user_logged;
        contest_settings.user_id_profile = this.props.short.user_id_profile;
        contest_settings = Object.assign(contest_settings, vote_settings);
        this.props.handleSaveVotes(
            this.props.singlepost.id,
            this.props.singlepost.term_id,
            contest_settings,
            post_index,
            this.props.email_address
        );
    };

    render() {
        const { t } = this.props;
        let error_login = null;

        const { show_verifycode } = this.props;

        return (
            <Dialog
                open={this.props.showlog}
                maxWidth="sm"
                fullWidth={true}
                onClose={() => this.props.handclose()}
            >
                <DialogContent>
                    <TextField
                        className="wpvc_text_field"
                        type="text"
                        name="email_address"
                        label={t("enter_email_to_verify")}
                        onChange={(event) =>
                            this.props.handleValueChange(event)
                        }
                        fullWidth
                        value={this.props.email_address}
                    />
                    {this.validator.message(
                        t("voter_email_required"),
                        this.props.email_address,
                        "required|email"
                    )}

                    <Newsletter {...this.props} email_field={true} />
                    <VoterDetails {...this.props} validator={this.validator} />

                    <Grid2 container justifyContent="flex-start">
                        <Typography className="wpvc_error_login">
                            {ReactHtmlParser(error_login)}
                        </Typography>
                        <Button
                            variant="contained"
                            className="wpvc_login_btns"
                            color="secondary"
                            onClick={this.handleEmailverify}
                            endIcon={<SendIcon />}
                            disabled={this.props.disabled}
                        >
                            {t("send_email_code")}
                        </Button>
                    </Grid2>

                    {show_verifycode === 1 && (
                        <Grid2 container justifyContent="flex-start">
                            <TextField
                                className="wpvc_text_field"
                                type="text"
                                name="enter_email_code"
                                label={t("enter_email_code")}
                                onChange={this.handleEmailCodeChange}
                                fullWidth
                            />

                            {this.validator.message(
                                t("verification_code_required"),
                                this.state.enter_email_code,
                                "required|verifycode"
                            )}

                            <Button
                                variant="contained"
                                className="wpvc_login_btns"
                                color="secondary"
                                onClick={this.handleVerificationCode}
                                endIcon={<VerifiedUserIcon />}
                            >
                                {t("verifiy_code")}
                            </Button>
                        </Grid2>
                    )}
                </DialogContent>
            </Dialog>
        );
    }
}

export default withTranslation("translations")(EmailVerify);
